import type { InjectionKey } from 'vue'
import { inject, provide } from 'vue'
import type { FiltersTopBarStore } from '@/components/filters/FiltersTopBarStore'

/** Entity types that the shared filter top-bar supports. */
export type FiltersTopBarEntity = 'Job' | 'Batch'

/**
 * pattern taken from bucketBridge
 */

export interface FilterContextBridge {
  store: FiltersTopBarStore
  entityType: FiltersTopBarEntity
}

export const filterContextBridgeKey: InjectionKey<FilterContextBridge> =
  Symbol('filterContextBridge')

export function useFilterContextProvider(bridge: FilterContextBridge): void {
  provide(filterContextBridgeKey, bridge)
}

export function useFilterContextBridge(): FilterContextBridge {
  const bridge = inject(filterContextBridgeKey)
  if (!bridge) {
    throw new Error(
      '[useFilterContextBridge] No FilterContextBridge found in the component tree. ' +
        'Make sure a parent component calls useFilterContextProvider().',
    )
  }
  return bridge
}
